import { render } from "./Responses.vue?vue&type=template&id=27d4e86d"
import script from "./Responses.vue?vue&type=script&lang=js"
export * from "./Responses.vue?vue&type=script&lang=js"

import "./Responses.vue?vue&type=style&index=0&id=27d4e86d&lang=scss"
script.render = render

export default script